// import { doc, getDoc, updateDoc } from "firebase/firestore";
// Replaced with backend API calls
import { useCallback } from 'react';
import API_URL from '../../../utils/api';

export default function useProfile({ auth, db, setUser, setSuccess, setError, setLoading, setEditField }) {
  // Logic only, states are in the component
  const fetchUser = useCallback(async (userId) => {
    try {
      // Add cache-busting param to always get fresh data
      const response = await fetch(`${API_URL}/api/profile/${userId}?t=${Date.now()}`);
      const result = await response.json();
      if (response.ok) {
        setUser(result);
      } else {
        setError(result.message || "Failed to fetch user profile.");
      }
    } catch (err) {
      setError("Failed to fetch user profile.");
    }
  }, [setUser, setError]);
  const handleEdit = (field, user, setEditValue) => {
    setEditField(field);
    setEditValue(user[field] || "");
    setSuccess("");
    setError("");
  };
  // Accepts either (userId, field, value) or (userId, updatedFields)
  const handleSave = async (userId, updatedFieldsOrField, value) => {
    setLoading && setLoading(true);
    setError && setError("");
    setSuccess && setSuccess("");
    let body;
    if (typeof updatedFieldsOrField === "object" && updatedFieldsOrField !== null) {
      body = updatedFieldsOrField;
    } else {
      body = { [updatedFieldsOrField]: value };
    }
    try {
      const response = await fetch(`${API_URL}/api/profile/${userId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (response.ok) {
        setSuccess && setSuccess("Profile updated!");
        setEditField && setEditField("");
        // If the backend returns the updated user, update state immediately
        if (result && typeof result === 'object' && result.id) {
          setUser && setUser(result);
        }
      } else {
        setError && setError(result.message || "Failed to update profile.");
      }
    } catch (err) {
      setError && setError("Failed to update profile.");
    }
    setLoading && setLoading(false);
  };
  return { fetchUser, handleEdit, handleSave };
}
